import { reduxForm } from 'redux-form';
import Component from './ForgotPassword';
import validate from './validate';

const initialValues = {
  email: '',
};

export default reduxForm({
  form: 'lupa-pin',
  initialValues,
  validate,
})(Component);
